import { render, staticRenderFns } from "./ViewTaskCommentModal.vue?vue&type=template&id=42dfc064&"
import script from "./ViewTaskCommentModal.vue?vue&type=script&lang=js&"
export * from "./ViewTaskCommentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports